import React, { type ReactElement } from 'react';

import type { SelectFilterOption } from '../../../constants/filters/select-filter/types';
import { type FilterOrControlId } from '../../../constants/filters/types';
import SelectFilter from '../select-filter';
import type { FilterProps } from './types';

type SharedSalesforceDynamicMultiSelectProps = FilterProps & {
	filterId: FilterOrControlId;
	label: string;
	noOptionsMessage: string;
	iconBefore: ReactElement | null;
	isLoading: boolean;
	selectedOptions: SelectFilterOption[];
	suggestedOptions: SelectFilterOption[];
	loadInitialOptions: () => void;
	setOption: (option: SelectFilterOption | SelectFilterOption[]) => void;
	clearOptions: () => void;
};

const SharedSalesforceDynamicMultiSelect = ({
	filterId,
	label,
	noOptionsMessage,
	iconBefore,
	isLoading,
	selectedOptions,
	suggestedOptions,
	loadInitialOptions,
	setOption,
	clearOptions,
	isFilterInDropdown,
	fit = 'default',
	onFilterChange,
	hideOnHoverOut,
	onClearOptions,
}: SharedSalesforceDynamicMultiSelectProps): React.JSX.Element => {
	const allOptions = [...selectedOptions, ...suggestedOptions];
	const resolvedLabel = fit === 'compact' && selectedOptions.length > 0 ? '' : label;

	return (
		<SelectFilter
			contentFit={fit}
			canClearFilter
			checkboxIndicators
			onDropdownOpen={() => {
				loadInitialOptions();
			}}
			onSelectChange={(option) => {
				setOption(option);
				onFilterChange?.(option);
			}}
			options={allOptions}
			selectedOptions={selectedOptions}
			label={resolvedLabel}
			filterOrControlId={filterId}
			isLoading={isLoading}
			isSearchable
			filterOption={null}
			noOptionsMessage={noOptionsMessage}
			onClearOptions={() => {
				clearOptions();
				onClearOptions?.({ filterId });
			}}
			isFilterInDropdown={isFilterInDropdown}
			iconBefore={iconBefore}
			hideOnHoverOut={hideOnHoverOut}
		/>
	);
};

export default SharedSalesforceDynamicMultiSelect;
